import AiCostsFilterView from '@UI/Pages/Administration/AiCosts/Filters/AiCostsFilterView';
import { createSignal } from '@verclam/pulsar';

const aiCostsFiltersSignal = createSignal<AiCostsFilterView>(AiCostsFilterView.createDefault());

export const setAiCostsFilters = (filters: AiCostsFilterView): void => {
	aiCostsFiltersSignal.value = filters;
};

export default aiCostsFiltersSignal;
